// extracted by mini-css-extract-plugin
module.exports = {"citysPart":"citysPart___2EsB7","head":"head___1F68s","title":"title___2P60u","subTitle":"subTitle___1wajL","cityList":"cityList___2OfZm","item":"item___25i3C"};